import { Button, Tooltip } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { useHasScopePermission } from "app/hooks";
import PlusIcon from "assets/icons/plus.svg?react";

export function GroupsActionBar() {
  const navigate = useNavigate();

  // addUserGroup is gated on ADD at the user-group scope, which "editor" on
  // system doesn't grant, so system EDIT isn't enough here.
  const hasPermission = useHasScopePermission();
  const canAddGroup = hasPermission("userGroup", "ADD");

  return (
    // Search and the identity-provider filter live in the directory below, so
    // the bar holds just the create action, aligned to the right.
    <div className="mb-6 flex items-center justify-end">
      <Tooltip
        title={
          canAddGroup
            ? ""
            : "You need the owner, creator or admin role to add a group"
        }
        asChild
      >
        <span>
          <Button
            IconLeft={<PlusIcon height={20} width={20} />}
            isDisabled={!canAddGroup}
            onPress={() => navigate("add")}
            variant="primary"
          >
            Create New Group
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
